package com.arena_web.ui.components.widgets

import androidx.compose.runtime.Composable
import com.arena_web.ui.theme.AppColors
import com.arena_web.ui.theme.withAlpha
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*

enum class BadgeVariant {
    PRIMARY, SUCCESS, WARNING, ERROR, NEUTRAL
}

@Composable
fun Badge(
    text: String,
    modifier: Modifier = Modifier,
    variant: BadgeVariant = BadgeVariant.PRIMARY
) {
    val (bgColor, textColor) = when (variant) {
        BadgeVariant.PRIMARY -> AppColors.Primary.withAlpha(0.15f) to AppColors.Primary
        BadgeVariant.SUCCESS -> Color.rgba(34, 197, 94, 0.15f) to Color.rgb(34, 197, 94)
        BadgeVariant.WARNING -> Color.rgba(245, 158, 11, 0.15f) to Color.rgb(245, 158, 11)
        BadgeVariant.ERROR -> AppColors.Error.withAlpha(0.15f) to AppColors.Error
        BadgeVariant.NEUTRAL -> Color.rgba(148, 163, 184, 0.15f) to Color.rgb(148, 163, 184)
    }

    Box(
        modifier = modifier
            .backgroundColor(bgColor)
            .sBorderRadius(12)
            .sPadding(4, 10),
        contentAlignment = Alignment.Center
    ) {
        SpanText(
            text,
            modifier = Modifier
                .sFontSize(12)
                .fontWeight(FontWeight.Medium)
                .color(textColor)
        )
    }
}

@Composable
fun Chip(
    text: String,
    modifier: Modifier = Modifier,
    variant: BadgeVariant = BadgeVariant.PRIMARY,
    onDismiss: (() -> Unit)? = null,
    onClick: (() -> Unit)? = null
) {
    val (bgColor, textColor) = when (variant) {
        BadgeVariant.PRIMARY -> AppColors.Primary.withAlpha(0.15f) to AppColors.Primary
        BadgeVariant.SUCCESS -> Color.rgba(34, 197, 94, 0.15f) to Color.rgb(34, 197, 94)
        BadgeVariant.WARNING -> Color.rgba(245, 158, 11, 0.15f) to Color.rgb(245, 158, 11)
        BadgeVariant.ERROR -> AppColors.Error.withAlpha(0.15f) to AppColors.Error
        BadgeVariant.NEUTRAL -> Color.rgba(148, 163, 184, 0.15f) to Color.rgb(148, 163, 184)
    }

    Row(
        modifier = modifier
            .backgroundColor(bgColor)
            .sBorderRadius(16)
            .sPadding(6, 12)
            .sGap(6)
            .then(
                if (onClick != null) Modifier.cursor(Cursor.Pointer).onClick { onClick() }
                else Modifier
            ),
        verticalAlignment = Alignment.CenterVertically
    ) {
        SpanText(
            text,
            modifier = Modifier
                .sFontSize(13)
                .fontWeight(FontWeight.Medium)
                .color(textColor)
        )

        if (onDismiss != null) {
            Box(
                modifier = Modifier
                    .sSize(16)
                    .borderRadius(50.percent)
                    .cursor(Cursor.Pointer)
                    .onClick { onDismiss() },
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    "\u00D7",
                    modifier = Modifier
                        .sFontSize(14)
                        .color(textColor)
                )
            }
        }
    }
}
